import React from "react";
import StoreHeader from "./store-header";
import StoreNav from "./store-nav";
import { useLocale } from "@/middleware";
import { LANG } from "@/types";
import Footer from "./footer";

function StoreLayout({ children }: { children: React.ReactNode }) {
  const { locale } = useLocale();
  return (
    <div
      className="pb-16 h-full"
      dir={locale === LANG.AR ? "rtl" : "ltr"}
    >
      <StoreHeader />
      <StoreNav />
      <div className="pt-0 md:pt-10 pb-16 md:pb-0">{children}</div>
      <Footer />
    </div>
  );
}

export default StoreLayout;
